(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter-slider"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilterSlider extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.collection-filter-swiper');

      if (typeof Swiper !== 'undefined') {
        this.initSwiper();
      } else {
        const swiperScript = document.querySelector('script[src*="swiper"]');
        if (swiperScript) {
          swiperScript.addEventListener('load', () => this.initSwiper());
        }
      }
    }

    initSwiper() {
      const slides = [...this.querySelectorAll('.swiper-slide')];
      const activeIndex = slides.findIndex((s) => s.classList.contains('is-active'));

      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slideToClickedSlide: true,
        mousewheel: { forceToAxis: true },
        initialSlide: Math.max(0, activeIndex),
        navigation: {
          nextEl: this.querySelector('.collection-filter-slider__next'),
          prevEl: null,
        },
        breakpoints: {
          768: {
            spaceBetween: 24
          }
        }
      });
    }
  }

  customElements.define('collection-filter-slider', CollectionFilterSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
